import { useMutation, useQueryClient } from '@tanstack/react-query';
import { settingsService } from '../services/settings.service';

export function useCancelSubscription() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => settingsService.cancelSubscription(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subscription'] });
    },
  });
}
